module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.userInfoTitle,
      "width": "45%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "userInfo",
    attrs: {
      "model": _vm.userInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [(_vm.userInfoOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userNames"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "多个用户名请用英文','分隔",
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.userInfo.userNames),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "userNames", $$v)
      },
      expression: "userInfo.userNames"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userInfoOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userName"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.userInfo.userName),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "userName", $$v)
      },
      expression: "userInfo.userName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限集合",
      "prop": "roleKey"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.userInfo.roleKey),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "roleKey", $$v)
      },
      expression: "userInfo.roleKey"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item.roleKey,
      attrs: {
        "label": item.roleName,
        "value": item.roleKey
      }
    })
  }))], 1)], 1), _vm._v(" "), (_vm.isShowNamespace && _vm.userInfoOperate === 'add') ? _c('el-form-item', {
    attrs: {
      "label": "所属域",
      "prop": "namespaces",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "multiple": "",
      "filterable": "",
      "remote": "",
      "placeholder": "请选择域名"
    },
    model: {
      value: (_vm.userInfo.namespaces),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "namespaces", $$v)
      },
      expression: "userInfo.namespaces"
    }
  }, _vm._l((_vm.allDomains), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isShowNamespace && _vm.userInfoOperate === 'edit') ? _c('el-form-item', {
    attrs: {
      "label": "所属域",
      "prop": "namespace",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "remote": "",
      "placeholder": "请选择域名"
    },
    model: {
      value: (_vm.userInfo.namespace),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "namespace", $$v)
      },
      expression: "userInfo.namespace"
    }
  }, _vm._l((_vm.allDomains), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }))], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d9a51bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/authority_manage/user_info_dialog.vue
// module id = 1395
// module chunks = 1